import React, { useEffect, useState } from "react";
import "./App.css";

function useAuthMe() {
  const [me, setMe] = useState(null);
  useEffect(() => {
    fetch("/.auth/me")
      .then((r) => (r.ok ? r.json() : null))
      .then((data) =>
        setMe(data && data.clientPrincipal ? data.clientPrincipal : null)
      )
      .catch(() => setMe(null));
  }, []);
  return me;
}

function App() {
  const me = useAuthMe();
  const isAuthed = !!me;

  return (
    <div className="app">
      <header className="header">
        <div className="brand">SchoolFlow</div>
        <div>
          {!isAuthed ? (
            <>
              <a className="btn" href="/.auth/login/aad">
                Sign in with Microsoft
              </a>
            </>
          ) : (
            <>
              <span style={{ marginRight: 8 }}>
                Hi, {me.userDetails || me.userId}
              </span>
              <a className="btn" href="/.auth/logout">
                Sign out
              </a>
            </>
          )}
        </div>
      </header>

      <main className="main">
        {!isAuthed ? (
          <div className="card">
            <h2>Welcome</h2>
            <p>
              Sign in to connect your mailbox and calendar. We’ll add school and
              sports events for you automatically.
            </p>
          </div>
        ) : (
          <div className="card">
            <h2>Getting started</h2>
            <ol>
              <li>Confirm your time zone</li>
              <li>Add your mobile for SMS updates</li>
              <li>Connect the mailbox to monitor (Outlook or Gmail)</li>
              <li>Choose your target calendar</li>
            </ol>
          </div>
        )}
      </main>
    </div>
  );
}

export default App;
